import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import Processing from '../../components/Processing';

import Api from '../../Api';

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.onSignIn = this.onSignIn.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    this.state = {
      error: null
    };
  }

  componentDidMount() {
    if (this.inputField) this.inputField.focus();
  }

  onSignIn() {
    let redirectQuery = this.props.location.query.redirect
        ? '?redirect=' + this.props.location.query.redirect
        : '';
    return Api.userLogin(this.inputField.value)
      .then(
        () => {
          let route = `/user/code/${this.inputField.value}${redirectQuery}`;
          this.context.router.push(route);
        },
        error => {
          this.setState({ error });
        }
      );
  }
  
  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.setState({ error: null });
      return this.submitButton.click(event);
    }
  }

  render() {
    let welcomeback = null;
    if (this.props.location.query.welcomeback) {
      welcomeback = <p className="note">Welcome back! Enter the email or phone number you provided when creating your account to receive your access code.</p>
    }

    let errorMessage = null;
    if (this.state.error && this.state.error.message) {
      errorMessage = <div className="error">{this.state.error.message}</div>;
    }

    return(
      <div className="page-flyout signin">
        <h2>Sign In</h2>
        {welcomeback}
        <div className="input">
          <input
            autoFocus
            type="text"
            ref={inputField => this.inputField = inputField}
            placeholder="Phone or Email"
            className="center"
            onKeyPress={this.onKeyPress}
          />
        </div>
        <div className="error-placeholder">
          {errorMessage}
        </div>
        <div>
          <Button
            ref={submitButton => this.submitButton = submitButton}
            onClick={this.onSignIn}
            waitingState={<Processing/>}
          >
            Request Sign In Code
          </Button>
        </div>
      </div>
    );
  }
}

SignIn.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/user/signin.js
 **/